import { AppSubdomains } from 'src/types/common';
import { getSubdomain } from 'src/utils/domain/getSubdomain';

const APP_HEADER_LOGOS: Record<AppSubdomains, string> = {
  [AppSubdomains.Pari]: '/pari-black.png',
  [AppSubdomains.Homebar]: '/homebar-logo.png',
  [AppSubdomains.Terea]: '/pari-logo.png',
};

const AUTH_LAYOUT_LOGOS: Record<AppSubdomains, string> = {
  [AppSubdomains.Pari]: '/pari-logo.png',
  [AppSubdomains.Homebar]: '/homebar-logo.png',
  [AppSubdomains.Terea]: '/pari-logo.png',
};

const LOADER_ICONS: Record<AppSubdomains, { Src: string; Width: string }> = {
  [AppSubdomains.Pari]: { Src: '/pari_logo_azul.png', Width: '220px' },
  [AppSubdomains.Homebar]: { Src: '/homebar-small-icon.png', Width: '150px' },
  [AppSubdomains.Terea]: { Src: '/pari_logo_azul.png', Width: '220px' },
};

const SECONDARY_LOGOS: Record<AppSubdomains, string> = {
  [AppSubdomains.Pari]: '/pari-logo.svg',
  [AppSubdomains.Homebar]: '/homebar-logo.png',
  [AppSubdomains.Terea]: '/pari-logo.svg',
};

const subdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);

export const APP_HEADER_LOGO = APP_HEADER_LOGOS[subdomain];
export const AUTH_LAYOUT_LOGO = AUTH_LAYOUT_LOGOS[subdomain];
export const LOADER_ICON = LOADER_ICONS[subdomain];
export const SECONDARY_LOGO = SECONDARY_LOGOS[subdomain];
